import { render, staticRenderFns } from "./NoActiveGames.vue?vue&type=template&id=8843d676"
import script from "./NoActiveGames.vue?vue&type=script&lang=js"
export * from "./NoActiveGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports